import accountsImage from "../../img/accounts.svg";
import coursesImage from "../../img/courses.svg";
import onlineProgramsImage from "../../img/OnlinePrograms.png";
import handsOnImage from "../../img/HandsOn.png";
import observationTrackImage from "../../img/ObservationTrack.svg";
import dentalAssistantObservationTrackImage from "../../img/DentistAssistantTrack.svg";
import masterOfOralImplantologyImage from "../../img/MasterOfOralImplantology.svg";
import saasIcon from "../../img/saas.svg";
import userIcon from "../../img/users.svg";
import OnlineProgramTestAttempts from "../../img/OnlineProgramTestAttempts.svg";
import PurchaeOnlineProgams from "../../img/purchaeonlineprograms.svg";
import subscriptionsIcon from "../../img/subscriptions.svg";
import SpeakersIcon from "../../img/Speakers.svg";
import liveLecturesImage from "../../img/LiveLectures.svg";
import navigations from "../../routes/routeNames";

export const sideBarIcons = [
  {
    img: accountsImage,
    navigateTo: navigations.ACCOUNTS,
    name: "Accounts",
    id: 1,
  },
  {
    img: masterOfOralImplantologyImage,
    navigateTo: navigations.MASTER_OF_ORAL_IMPLANTOLOGY,
    name: "Master of Oral Implantology Program",
    id: 2,
  },
  {
    img: coursesImage,
    navigateTo: navigations.LIVE_EXTERNSHIP,
    name: "Live-Patient Externships - Participation Track",
    id: 3,
  },
  {
    img: observationTrackImage,
    navigateTo: navigations.LIVE_EXTERNSHIP_OBSERVATION,
    name: "Live-Patient Externships - Observation Track",
    id: 4,
  },
  {
    img: dentalAssistantObservationTrackImage,
    navigateTo: navigations.LIVE_EXTERNSHIP_DENTAL_ASSISTANT,
    name: "Live-Patient Externships - Dental Assistant Observation Track",
    id: 5,
  },

  {
    img: handsOnImage,
    navigateTo: navigations.CADAVER_PROGRAM,
    name: "Hands-On Cadaver Programs",
    id: 6,
  },
  {
    img: onlineProgramsImage,
    navigateTo: navigations.ONLINE_PROGRAM,
    name: "Online Programs",
    id: 7,
  },
  {
    img: liveLecturesImage,
    navigateTo: navigations.LIVE_LECTURES,
    name: "Live Lectures",
    id: 14,
  },

  // {
  //   img: OnlineProgramRequest,
  //   navigateTo: navigations.ONLINE_PROGRAM_REQUEST,
  //   name: "Online Program CE Requests",
  //   id: 5,
  // },
  {
    img: OnlineProgramTestAttempts,
    navigateTo: navigations.USERS_TEST_ATTEMPTS,
    name: "Users Test Attempts",
    id: 8,
  },

  {
    img: PurchaeOnlineProgams,
    navigateTo: navigations.PURCHASE_ONLINE_PROGRAMS,
    name: "Purchased Programs",
    id: 9,
  },
  {
    img: subscriptionsIcon,
    navigateTo: navigations.SUBSCRIPTIONS,
    name: "Subscriptions",
    id: 10,
  },
  {
    img: SpeakersIcon,
    navigateTo: navigations.SPEAKERS,
    name: "Speakers",
    id: 11,
  },
  {
    img: saasIcon,
    navigateTo: navigations.SAAS,
    name: "Saas",
    id: 12,
  },

  {
    img: userIcon,
    navigateTo: navigations.USERS,
    name: "Users",
    id: 13,
  },
];
